module.exports = __webpack_public_path__ + "static/media/Grand Square Cam 03 Still 2.02be483d.webp";